import React, { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getWaiverById } from "../../../api/historyService";
import { cleanHtmlString } from "../../../utils/cleanHtmlString";

const WaiverDisplay = ({ id }) => {
  const { t } = useTranslation("common");
  const [data, setData] = useState(null);
  const [message, setMessage] = useState(t("waiver.messages.wait"));
  const [logoImgSrc, setLogoImgSrc] = useState("");

  const baseApiUrl = process.env.REACT_APP_API_URL;
  const publicUploadsFolder = "public_uploads";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getWaiverById(id);
        setData(data);
        const bustCache = Date.now();
        setLogoImgSrc(`${baseApiUrl}/${publicUploadsFolder}/logo-${data.office.id}.png?${bustCache}`);
      } catch (error) {
        setMessage("Waiver not found");
      }
    };
    fetchData();
  }, [id]);

  if (!data) {
    return (
      <Typography variant="body1" sx={{ flexGrow: 1, marginBottom: "1rem" }}>
        {message}
      </Typography>
    );
  }

  return (
    <div id="print-section">
      <Box 
        component="img" 
        src={logoImgSrc} 
        alt="logo" 
        sx={{ maxHeight: 80, display: "block" }} 
        onError={(e) => {
          e.currentTarget.src = "/images/logo-0.png";
        }}
      />
      <Typography variant="body2">{data.office.name}</Typography>
      <Typography variant="body2">{data.office.address}</Typography>
      <Typography variant="body2">{`tel. no. ${data.office.contact_number} e-mail ${data.office.email}`}</Typography>
      <br />
      
      <div
        style={{
          width: "700px",
          whiteSpace: "normal",
          overflowWrap: "break-word",
          wordBreak: "break-word",
          hyphens: "auto",          // adds natural hyphenation
        }}
        dangerouslySetInnerHTML={{ __html: cleanHtmlString(data.content) }} 
      />
      
    </div>
  );
};

export default WaiverDisplay;
